import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import Styles from './themes/OktaWidgetWraperDark.css';

const OktaWidgetWraper = (props) => {

  const {
    config,
    logoSrc,
    OktaSignIn,
    widgetSuccessCallback,
    widgetErrorCallback,
    errorMessage
  } = props;

  config.oidc.logo = logoSrc;
  const {
    protocol,
    host,
    search
  } = window.location;

  config.oidc.redirectUri = `${protocol}//${host}/login`;

  const [signInWidget, setSignInWidget] = useState(null);

  const createInstance = () => {
    const signInWidgetInstance = new OktaSignIn(config.oidc);

    signInWidgetInstance.on('ready', () => {
      if (errorMessage) {
        const errContainer = document.querySelector('.o-form-error-container');
        errContainer.classList.add('o-form-has-errors');
        errContainer.innerHTML = `<div><div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>${errorMessage}</p></div></div>`;
      }
    });

    signInWidgetInstance.renderEl(
      { el: '#okta-widget' },
      widgetSuccessCallback,
      widgetErrorCallback
    );

    setSignInWidget(signInWidgetInstance);
  };

  useEffect(() => {
    const params = new URLSearchParams(search);
    const token = params.get('token');

    document.getElementById('okta-widget').innerHTML = '';

    if(!signInWidget){
      if (token) {
        config.oidc.recoveryToken = token;
      }

      config.oidc.features.registration = false;
      config.oidc.features.selfServiceUnlock = false;

      createInstance();
    }
  }, []);

  useEffect(() => {
    if (!errorMessage || !signInWidget) {
      return;
    }
    signInWidget.remove();

    createInstance();
  }, [errorMessage]);

  return(
    <div className={Styles.container}>
      <div id="okta-widget" />
      <div className={Styles.termsTextRow}>
        <span>
          By clicking Sign In, you have read, understand, and agree to our
          <a href="http://zignallabs.com/zignal-terms-and-conditions"> Terms.</a>
        </span>
      </div>
    </div>
  );
};

OktaWidgetWraper.propTypes = {
  config: PropTypes.object,
  logoSrc: PropTypes.string,
  notificationMessage: PropTypes.string,
  OktaSignIn: PropTypes.any,
  widgetSuccessCallback: PropTypes.func,
  widgetErrorCallback: PropTypes.func,
};
export default themeable(OktaWidgetWraper);
